export const radius = {
    radius0: '0',
    radius100: '4px',
    radius200: '6px',
    radius300: '8px',
    radius400: '12px',
    radiusRound: '999px',
};
//# sourceMappingURL=radius.js.map